export async function startRazorpayCheckout() {
  throw new Error('Razorpay checkout is disabled in the Shopify build.')
}
